export default [
    {
        path: '/website-news',
        props: true,
        component: () => import('@/views/WebsiteNewsPage'),
    },
];
